import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import SelfHostedAuth from "./Components/Auth/SelfHostedAuth"; // another option: use HostedUI
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs, HandlerType } from "@datadog/browser-logs";
import config from "./config";

const datadogConfig = {
  applicationId: "f97d4d39-8fa8-42ce-b99f-07637232283c",
  clientToken: "pub45bd094d84bc4333604b4403be153164",
  site: "datadoghq.com",
  service: "operations-ui",
  env: process.env.REACT_APP_ENV,
  sampleRate: 100,
  trackInteractions: true
};

if (config.datadogEnabled === "true") {
  datadogRum.init(datadogConfig);
}

datadogLogs.init(datadogConfig);

datadogLogs.onReady(() => {
  datadogLogs.logger.setHandler([HandlerType.http, HandlerType.console]);
});

ReactDOM.render(
  <SelfHostedAuth>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </SelfHostedAuth>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
